import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function ChevronLeftSingle({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 0.46875C6.97266 0.46875 0.46875 6.97266 0.46875 15C0.46875 23.0273 6.97266 29.5312 15 29.5312C23.0273 29.5312 29.5312 23.0273 29.5312 15C29.5312 6.97266 23.0273 0.46875 15 0.46875ZM27.6562 15C27.6562 21.9551 22.0254 27.6562 15 27.6562C8.04492 27.6562 2.34375 22.0254 2.34375 15C2.34375 8.04492 7.97461 2.34375 15 2.34375C21.9551 2.34375 27.6562 7.97461 27.6562 15ZM18.9316 20.1738L14.1738 16.7168C13.9922 16.582 13.8867 16.3711 13.8867 16.1484V6.79688C13.8867 6.41016 14.2031 6.09375 14.5898 6.09375H15.4102C15.7969 6.09375 16.1133 6.41016 16.1133 6.79688V15.3691L20.2441 18.375C20.5605 18.6035 20.625 19.043 20.3965 19.3594L19.916 20.0215C19.6875 20.332 19.248 20.4023 18.9316 20.1738Z"
        fill={color}
      />
    </svg>
  );
}
